import createWrappedField from 'ddiForm/wrapped/createWrappedField'
import Search from '../../components/PurchaseOrderSearch'

export default createWrappedField({
  Component: Search,
  name: 'DDIPurchaseOrderSearchMobile'
})
